import { useEffect, useState } from 'react'
import { getHeroImagesForPath } from '../data/heroImages'
import { isImageCached, loadImage, wait } from '../utils/imageLoad'

export const MIN_LOADER_MS = 1500

const loadFonts = async () => {
  if (!document.fonts?.load) {
    return
  }

  await Promise.all([
    document.fonts.load('400 1em Inter'),
    document.fonts.load('600 1em Inter'),
    document.fonts.load('400 1em Tajawal'),
    document.fonts.load('700 1em Tajawal'),
  ])
  await document.fonts.ready
}

let fontsLoaded = false

export const usePageLoader = (pathname) => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    let cancelled = false
    setIsReady(false)

    const prepare = async () => {
      if (!fontsLoaded) {
        await loadFonts()
        fontsLoaded = true
      }

      const heroImages = getHeroImagesForPath(pathname)
      const heroesCached =
        heroImages.length === 0 || heroImages.every(isImageCached)

      if (heroesCached) {
        await wait(MIN_LOADER_MS)
      } else {
        await Promise.all(heroImages.map(loadImage))
      }

      if (!cancelled) {
        setIsReady(true)
      }
    }

    prepare()

    return () => {
      cancelled = true
    }
  }, [pathname])

  return isReady
}
